/*
	File: pagination.js
	Author: D McCleod
	Created: 2/13/2017
	Modified:
	Description: update pagination on hashchange / slide change
*/


//import { slideCount } from './dev.slideshow';

var pagination = {};

pagination.setInitialSlide = function(start) {
    pagination.currentSlideText.html(start);
};

pagination.setTotalSlides = function(total){
    $('.crs-pagination_total').html(total);
};

pagination.update = function(num) {
    pagination.currentSlideText.html(num);
}; 

pagination.init = function(){
    pagination.currentSlideText = $('.crs-pagination_current')
        .on('pagination:update', function(e, data) {
            pagination.update(data.currentSlide);
        });
};



export { pagination };
